import TaskTypeDTO from "./taskTypeDTO";

export class TaskCheckListConversionDTO {
  taskId: number;

  taskType?: TaskTypeDTO;

  trans_FormSuffix: string;

  trans_KPISuffix: string;

  constructor() {
    this.taskId = 0;
    this.trans_FormSuffix = '';
    this.trans_KPISuffix = '';
  }
}
